// lib/sentence-segmenter.ts
export const SEGMENT_MIN_CHARS = 30;
export const SEGMENT_MAX_CHARS = 120;

// Caracteres de cierre de frase. Cubre ".", "?", "!", "…" y el "\n\n".
const CLOSE_CHARS = new Set([".", "?", "!", "…"]);

interface SegmentState {
  buffer: string;
  closed: boolean;
}

async function* segmentTextImpl(
  source: AsyncIterable<string>,
): AsyncIterable<string> {
  const state: SegmentState = { buffer: "", closed: false };

  function tryEmit(): string | null {
    if (state.buffer.length === 0) return null;

    // Buscar el primer close char a partir de SEGMENT_MIN_CHARS
    let boundaryIdx = -1;
    for (let i = SEGMENT_MIN_CHARS - 1; i < state.buffer.length; i++) {
      if (CLOSE_CHARS.has(state.buffer[i])) {
        boundaryIdx = i + 1;
        break;
      }
      // Doble salto de línea también cierra
      if (
        state.buffer[i] === "\n" &&
        i + 1 < state.buffer.length &&
        state.buffer[i + 1] === "\n"
      ) {
        boundaryIdx = i + 2;
        break;
      }
    }

    // Forzar chunk si excede el máximo sin cerrar
    if (boundaryIdx === -1 && state.buffer.length >= SEGMENT_MAX_CHARS) {
      boundaryIdx = SEGMENT_MAX_CHARS;
    }

    // Si el stream cerró y queda remanente, emitirlo
    if (boundaryIdx === -1 && state.closed) {
      boundaryIdx = state.buffer.length;
    }

    if (boundaryIdx === -1) return null;

    const out = state.buffer.slice(0, boundaryIdx).trim();
    state.buffer = state.buffer.slice(boundaryIdx);
    return out.length > 0 ? out : null;
  }

  for await (const chunk of source) {
    state.buffer += chunk;
    let emitted: string | null;
    while ((emitted = tryEmit()) !== null) {
      yield emitted;
    }
  }

  state.closed = true;
  const tail = tryEmit();
  if (tail) yield tail;
}

export async function* segmentText(
  source: AsyncIterable<string>,
): AsyncIterable<string> {
  yield* segmentTextImpl(source);
}
